import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

// The four Insights pages read as one area: same tabs on each, in the order
// of the sidebar's Insights group, so moving between them never needs the
// menu. Each page still handles its own plan gating.
const TABS = [
  { path: '/analytics/impact', label: 'Business impact' },
  { path: '/lead-intelligence', label: 'Lead insights' },
  { path: '/support-insights', label: 'Support insights' },
  { path: '/missed-opportunities', label: 'Missed opportunities' },
];

const InsightsTabs = () => {
  const { tenantId } = useParams();
  const base = tenantId ? `/t/${tenantId}` : '/platform';
  return (
    <nav aria-label="Insights" className="mb-6 overflow-x-auto border-b border-gray-200 dark:border-gray-700">
      <ul className="flex gap-1 whitespace-nowrap">
        {TABS.map((tab) => (
          <li key={tab.path}>
            <NavLink
              to={`${base}${tab.path}`}
              end
              className={({ isActive }) => `inline-flex min-h-[44px] items-center border-b-2 px-3 text-sm font-semibold ${
                isActive
                  ? 'border-indigo-600 text-indigo-700 dark:text-indigo-300'
                  : 'border-transparent text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white'
              }`}
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default InsightsTabs;
